import { Reveal } from '../Reveal';
import { SectionHeader } from '../SectionHeader';
import { BrowserFrame, CheckList, DemoCaption } from '../compass/shared';

// Section 6 — Compliance Health and Group View. Figures are demonstration
// data; a score is never a legal determination or certification.
export const ForeseeComplianceHealth = ({ sp }) => (
  <section aria-labelledby="foresee-health-heading" data-testid="foresee-health" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <SectionHeader
            align="left"
            eyebrow="Management Visibility"
            title="See compliance health across the organisation"
            description={sp.visibilityCopy}
            testid="foresee-health-header"
          />
          <div className="mt-8">
            <CheckList items={sp.visibilityPoints || []} testid="foresee-health-points" />
          </div>
          <p className="mt-6 border-l-2 border-indigo-500 pl-4 text-sm font-medium leading-relaxed text-slate-600">
            A compliance score is a management indicator only — never a legal determination or a certification.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <BrowserFrame shot={sp.shots.dashboard} label="Foresee — demonstration workspace" />
          <DemoCaption />
        </Reveal>
      </div>
    </div>
  </section>
);
